import { Box } from '@mui/material';
import React from 'react';

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: number;
}

const TabPanel = ({ children, value, index, ...other }: TabPanelProps) => {
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            sx={{ width: '100%'}}
            {...other}
        >
            {value === index && <Box sx={{ pl: 0, pr: 0, justifyContent: 'space-between', height: '100%'  }}>{children}</Box>}
        </Box>
    );
};

export { TabPanel };
